import { productionPlans } from "@/api/productionPlan/useProductionPlanQuery";
import { LotTrackingLedgerTrackingContent } from "@/features/lotTracking/components/ledgerTracking";
import { useLotTrackingActions } from "@/features/lotTracking/hook/useLotTrackingActions";
import { useLotTrackingState } from "@/features/lotTracking/hook/useLotTrackingState";
import { LotTrackingReverceItemContent } from "@/features/lotTracking/reverce/components/reverceItem";
import { LotTrackingReverceLedgerTracking } from "@/features/lotTracking/reverce/components/reverceLedgerTracking";
import { LotTrackingReverceSummaryContent } from "@/features/lotTracking/reverce/components/reverceSummary";
import { LotTrackingReverceWorkHistoryContent } from "@/features/lotTracking/reverce/components/reverceWorkHistory";
import { LotTrackingReverceActionHeader } from "@/features/lotTracking/reverce/header/lotReverceActionHeader";
import { Flex, Text, Title } from "@mantine/core";
import { ProductionPlansConsumedLotIdLotIdGet200Response } from "@sizlcorp/sizl-api-document/dist/models";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const LotTrackingRevercePage = () => {
  const state = useLotTrackingState();
  const actions = useLotTrackingActions();
  const location = useLocation();

  useEffect(() => {
    // 필요한 경우 조건 추가
    if (state.itemCodeValue && state.lotId && location.state?.value === "click") {
      actions.setProductionPlan(undefined);
    } else if (state.itemCodeValue || state.lotId || state.productionPlan) {
      actions.setProductionPlan(undefined);
      actions.setLotId(null);
      actions.setItemCodeValue(null);
    }
  }, []);

  const { data: consumedLot } = useQuery({
    ...productionPlans.productionLot({
      lotId: Number(state.lotId),
    }),
    enabled: !!state.lotId,
  });

  return (
    <Flex w="100%" h="100%" direction="column">
      <Flex px="sm">
        <LotTrackingReverceActionHeader />
      </Flex>
      <Flex direction={"column"}>
        <Title p={"sm"} mb={8} order={1}>
          역방향 로트 추적
        </Title>
        <Text fz={12} p={"sm"}>
          특정 로트가 생산되기 위해 사용된 모든 원부자재의 로트를 파악할 수 있는 페이지입니다.
        </Text>
        <LotTrackingReverceItemContent />
        <LotTrackingReverceSummaryContent
          consumedLotData={consumedLot?.data as ProductionPlansConsumedLotIdLotIdGet200Response[]}
        />
        <LotTrackingReverceWorkHistoryContent />
        <LotTrackingLedgerTrackingContent
          consumedLotData={consumedLot?.data as ProductionPlansConsumedLotIdLotIdGet200Response[]}
          reverce={true}
        />
        <LotTrackingReverceLedgerTracking />
        {/* <LotTrackingQualityHistoryContent /> */}
      </Flex>
    </Flex>
  );
};
